(function(){
    'use strict'

    angular
    .module('app.nacionalidades')
    .controller('Nacionalidades', Nacionalidades);

    Nacionalidades.$inject = ['$animationsSrv', 'NacionalidadesService', 'logger', '$location', 'UserInfoService'];

    function Nacionalidades($animationsSrv, NacionalidadesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.nacionalidades = [];
        vm.title = 'Nacionalidades';

        vm.goToEdit = function(nacionalidad){
            
            var path = '/editar-nacionalidad/';

            if(nacionalidad){
                $location.path(path + nacionalidad.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = NacionalidadesService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(nacionalidades){
                vm.nacionalidades = nacionalidades;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las nacionalidades.');
                        break;
                }
            });
        };

        vm.delete = function(nacionalidad){
            var promise = NacionalidadesService.remove(nacionalidad);
            
            promise
            .then(function(response){
                vm.nacionalidades = vm.nacionalidades.filter(function(g) {
                    return g.id !== nacionalidad.id;
                });
                logger.success('Nacionalidad eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar La nacionalidad');
                        break;
                }
                
            });   
        };

    }
})();